import React from "react";
import { Link } from "react-router-dom";

// Polaris linkComponent: in-app URLs go through react-router (no full reload),
// anything external or downloadable stays a plain anchor.
export default function RouterLink({ children, url = "", external, download, ...rest }) {
  if (external || download || /^(https?:|mailto:|tel:|blob:|data:)/.test(url)) {
    return (
      <a href={url} download={download} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={url} {...rest}>
      {children}
    </Link>
  );
}
